// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let Form__TextInput = require("../../common/Components/Form__TextInput.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");

function WizardExactPriceField(props) {
  let __showFieldValidations = props.showFieldValidations;
  let price = props.price;
  let showFieldValidations = __showFieldValidations !== undefined ? __showFieldValidations : true;
  let status = showFieldValidations ? price.status : undefined;
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: props.width,
    widthMd: props.widthMd,
    children: [
      JsxRuntime.jsx(Form__TextInput.make, {
        labelText: props.labelText,
        onChange: event => price.onChange(Form__Helpers.intFromFormattedPrice(event)),
        onBlur: param => price.onBlur(),
        onFocus: param => price.onFocus(),
        status: status,
        prepend: "$",
        value: Form__Helpers.intOptToFormattedPrice(price.value)
      }),
      showFieldValidations ? JsxRuntime.jsx(Form__Components.FieldError.make, {
          valid: price.valid
        }) : null
    ]
  });
}

let Cell;

let TextInputField;

let make = WizardExactPriceField;

exports.Cell = Cell;
exports.TextInputField = TextInputField;
exports.make = make;
/* Form__Helpers Not a pure module */
